import queries from '@apis/queries';
import useOnLifecycleChanged from '@hooks/native/useOnLifecycleChanged';
import { useQueryClient } from '@tanstack/react-query';
import { useCookies } from 'react-cookie';

function useLifeCycleReIssue() {
    const [cookies] = useCookies(['refreshToken']);
    const { refreshToken } = cookies;
    const queryClient = useQueryClient();

    useOnLifecycleChanged({
        deps: [refreshToken],
        callbackFn: async () => {
            queryClient.invalidateQueries({ queryKey: queries.user._def });
            queryClient.invalidateQueries({ queryKey: queries.cart._def });
            queryClient.invalidateQueries({ queryKey: queries.notifications._def });
            queryClient.invalidateQueries({ queryKey: queries.stamps._def });
            queryClient.invalidateQueries({ queryKey: queries.coupons._def });
            queryClient.invalidateQueries({ queryKey: queries.inquiry._def });
            queryClient.invalidateQueries({ queryKey: queries.shop._def });
        },
    });
}

export default useLifeCycleReIssue;
